export default __webpack_public_path__ + "static/media/Image.276154f5.png";